var exports = {
  "Z": "x234b8571--66e612--layout",
};

module.exports = exports;
